import { Controller } from "@hotwired/stimulus"

// Righe di dettaglio del form di review: aggiunta/rimozione righe e totale
// indicativo client-side. Il ricalcolo autoritativo resta server-side al save.
export default class extends Controller {
  static targets = ["rows", "template", "row", "total"]

  add() {
    this.rowsTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML)
    this.refresh()
  }

  remove(event) {
    if (this.rowTargets.length <= 1) return // almeno una riga
    event.target.closest("[data-invoice-lines-target='row']").remove()
    this.refresh()
  }

  refresh() {
    const total = this.rowTargets.reduce((sum, row) => {
      const input = row.querySelector("input[name='self_invoice[lines][][amount_eur]']")
      return sum + (parseFloat(input.value.replace(",", ".")) || 0)
    }, 0)
    this.totalTarget.textContent = total.toFixed(2)
  }
}
